const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/search.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";
import { httpClient } from "@/lib/http-client";
import { formSchema } from "@/stores/searchStore";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/search")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ctx => {
    const {
      context
    } = ctx;
    const {
      country,
      queryClient
    } = context;

    // Only prefetch tags on initial load - SearchContainer handles search results client-side
    await queryClient.ensureQueryData({
      queryKey: ["all-tags"],
      queryFn: () => httpClient.get("/search/tags?raw=true").catch(() => null)
    });
    return {
      country
    };
  },
  validateSearch: zodSearchValidator(formSchema),
  head() {
    return {
      meta: [{
        title: i18n.t("search.meta.title")
      }, {
        name: "description",
        content: i18n.t("search.meta.description")
      }, {
        name: "og:title",
        content: i18n.t("search.meta.title")
      }, {
        name: "og:description",
        content: i18n.t("search.meta.description")
      }, {
        property: "twitter:title",
        content: i18n.t("search.meta.title")
      }, {
        property: "twitter:description",
        content: i18n.t("search.meta.description")
      }]
    };
  }
});